<template>
  <ValidationObserver ref="rejectDocumentForm">
    <BaseDialog isOpen>
      <template v-slot:title>
        Reason for Rejection
      </template>
      <template v-slot:body>
        <ValidationProvider v-slot="{ errors }" name="reason" rules="required">
          <v-textarea
            :error-messages="showValidationErrors ? errors : ''"
            v-model="reason"
            required
            class="mt-2"
          />
        </ValidationProvider>
      </template>
      <template v-slot:actions>
        <div>
          <PrimaryButton @click.native="cancel" text>
            Cancel
          </PrimaryButton>
          <ErrorButton @click.native="handleSubmit" :loading="isLoading">
            Reject Document
          </ErrorButton>
        </div>
      </template>
    </BaseDialog>
  </ValidationObserver>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import {
  REJECT_DOCUMENT,
  ADD_OFFER_DOCUMENT_COMMENT
} from "@/store/modules/offers/actions";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "RejectDocumentDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    ErrorButton,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      showValidationErrors: false,
      isLoading: false,
      reason: ""
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    },
    currentDocumentId() {
      return this.$route.params.documentId;
    }
  },
  methods: {
    ...mapActions({
      rejectDocument: REJECT_DOCUMENT,
      addComment: ADD_OFFER_DOCUMENT_COMMENT
    }),
    async handleSubmit() {
      this.showValidationErrors = true;
      const isFormValid = await this.$refs.rejectDocumentForm.validate();
      if (isFormValid) {
        this.isLoading = true;
        await this.rejectDocument({
          offerId: this.currentOfferId,
          documentId: this.currentDocumentId
        });
        await this.addComment({
          body: this.reason,
          // WIP
          commentableType: "offer_document",
          commentableId: this.currentDocumentId
        });
        this.cancel();
        this.isLoading = false;
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
